module.exports = __webpack_public_path__ + "static/quiz_manger-704b38769fe9bbf5c9df898442ee6438.webm";